module.exports = __webpack_public_path__ + "img/36.8321b701.png";